import {
  css,
  CSSObject,
  DefaultTheme,
  Interpolation,
  InterpolationFunction,
  ThemedStyledProps,
} from 'styled-components';

export const cardMobile = <P extends object>(
  first:
    | TemplateStringsArray
    | CSSObject
    | InterpolationFunction<ThemedStyledProps<P, DefaultTheme>>,
  ...interpolations: Array<Interpolation<ThemedStyledProps<P, DefaultTheme>>>
) => {
  return css`
    ${({ theme }) => theme.breakpoints.down('md')} {
      ${css(first, ...interpolations)};
    }
  `;
};
